<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-07-16 16:52:43
 * @LastEditTime: 2020-11-20 16:13:49
-->
<template>
  <div>
    <table>
            <tr>
              <th>{{$t('lang.particulars.connection')}}</th>
              <td v-if="list.deviceIsconnected==3">{{$t('lang.particulars.connected')}}</td>
              <td v-else-if="list.deviceIsconnected!=3">{{$t('lang.particulars.not')}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.foreach')}}</th>
              <td v-if="list.deviceCreate">{{list.deviceCreate}}</td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <th>{{$t('lang.particulars.CurTime')}}</th>
              <td v-if="list.onlineTime">{{getDuration(list.onlineTime)}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.beforeoffline')}}</th>
              <td v-if="list.offlineTime">{{getDuration(list.offlineTime)}}</td>
              <td v-else>N/A</td>
            </tr>
            <tr v-if="list.deviceIsconnected==3">
              <th>{{$t('lang.particulars.LoginTime')}}</th>
              <td v-if="list.deviceOnline">{{list.deviceOnline}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.online_updated')}}</th>
              <td v-if="list.thisOnlineTime">{{getDuration(list.thisOnlineTime)}}</td>
              <td v-else>N/A</td>
            </tr>
            <tr v-else>
              <th>{{$t('lang.particulars.TimeModeSetOffline')}}</th>
              <td v-if="list.deviceOffline">{{list.deviceOffline}}</td>
              <td v-else>N/A</td>
              <th>{{$t('lang.particulars.SCLocalTime')}}</th>
              <td v-if="list.thisOfflineTime">{{getDuration(list.thisOfflineTime)}}</td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <th>{{$t('lang.particulars.OnlineTimes')}}</th>
              <td>{{list.deviceLoginTimes?Number(list.deviceLoginTimes)>1000?'-':list.deviceLoginTimes:'-'}}</td>
              <th>{{$t('lang.particulars.OfflineTimes')}}</th>
              <td>{{list.deviceLogoutTimes?Number(list.deviceLogoutTimes)>1000?'-':list.deviceLogoutTimes:'-'}}</td>
            </tr>
            <tr>
              <th>{{$t('lang.particulars.Operation')}}</th>
              <td>
                <el-button type="danger" size="mini" @click="clearOnlineTime">{{$t('lang.particulars.statusClear')}}</el-button>
              </td>
            </tr>
          </table>
  </div>
</template>
<script>
import { clearLineTime } from '@/api/particulars'
export default {
  props: ['list'],
  data() {
    return {
      
    }
  },
  created() {
  },
  methods: {
     //计算毫秒数
    getDuration(mss) {
      let days = parseInt(mss / (1000 * 60 * 60 * 24));
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      return (
        days +
        this.$t("lang.particulars.Day") +
        hours +
        this.$t("lang.particulars.hours") +
        minutes +
        this.$t("lang.particulars.minutes") +
        seconds +
        this.$t("lang.particulars.seconds")
      );
    },
    // 在线/离线时长
    clearOnlineTime() {
      this.$confirm(this.$t('lang.DeleteBox.Tetx'), this.$t('lang.Button.tips'), {
        cancelButtonText:  this.$t('lang.Button.cancel'),
        confirmButtonText: this.$t('lang.Button.confirm'),
        type: 'warning',
        center: true
      }).then(() => {
        clearLineTime(this.list.deviceDid).then(res => {
          if(res.data.code === 0) {
            this.$message.success(this.$t('lang.Button.successOperation'))
            this.$emit('showDeviceDetail')
          }else{
            this.$message.error(this.$t('lang.Button.failOperation'))
          }
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>
<style scoped src='./particulars.css'></style>